import {
  GET_ALL_CARRIERS,
  GET_CARRIER
} from 'src/store/mutation-types'

export default {
  [GET_ALL_CARRIERS] (state, carriers) {
    state.carriers = carriers
  },
  [GET_CARRIER] (state, carrier) {
    state.carrier = carrier
  }
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/mutations.js